import { createSlice } from '@reduxjs/toolkit';

const productSlice = createSlice({
  name: 'products',
  initialState: {
    data: [],
    loading: true,
    error: null,
  },
  reducers: {
    startLoading: (state) => {
      if (!state.data) {
        state.loading = true;
      }
    },
    loadSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    loadFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    addProduct: (state, action) => {
      state.data.push(action.payload);
    },
    removeProduct: (state, action) => {
      state.data = state.data.filter(product => product.id !== action.payload);
    },
  },
});

export const { startLoading, loadSuccess, loadFailure, addProduct, removeProduct } = productSlice.actions;
export default productSlice.reducer;